import React from 'react';
import clsx from 'clsx';
import { Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const Error = ({
  error,
  className,
  onDismiss,
  warning,
  title,
}) => {
  const intl = useIntl();
  return (
    <Message
      className={clsx('aridhia-error', className)}
      error={!warning}
      warning={warning}
      size="small"
      icon={warning ? 'warning circle' : 'times circle'}
      key="error"
      header={title || intl.formatMessage({ id: 'error.title' })}
      content={error}
      onDismiss={onDismiss}
    />
  );
};

export default Error;
